export default __webpack_public_path__ + "static/media/anshu_web.6ae7b5bf.png";